import Faq from '../../components/ui/FAQ/Faq'

import styles from "./styles.module.scss"

const FaqPage = () => {
  return (
    <div className={styles.faqPage}>
        <Faq headingLevel={1} />
    </div>
  )
}

export default FaqPage